import gql from "graphql-tag";

export default gql`
	query School($id: String!) {
		School(id: $id) {
			id
			name
			urn
			la_name
			la_code
			establishment_number
			address_postcode
			address_line_1
			address_town
			phase_of_education
			address_line_2
			country_name
			country_iso_3166_2
			installed
			shard_region_code
			online
			last_heartbeat_at
			app_version
			uses_wonde_client
			mis_name
			demo
			active
			State {
				id
				state
				Company {
					id
					name
					application_name
					application_logo
				}
				enterprise_state
			}
			Settings {
				is_active
			}
			Contact {
				email
				notes
			}
		}
	}
`;
